import apiClient from "./axios"

// Get all quotation statuses with optional filters
export const getQuotationStatuses = async (params = {}) => {
  const { data } = await apiClient.get("/quotation-statuses", { params })
  return data
}

// Get a specific quotation status by ID
export const getQuotationStatus = async id => {
  const { data } = await apiClient.get(`/quotation-statuses/${id}`)
  return data
}

// Create a new quotation status
export const createQuotationStatus = async statusData => {
  const { data } = await apiClient.post("/quotation-statuses", statusData)
  return data
}

// Update an existing quotation status
export const editQuotationStatus = async ({ id, ...statusData }) => {
  const { data } = await apiClient.patch(`/quotation-statuses/${id}`, statusData)
  return data
}

// Soft delete a quotation status
export const deleteQuotationStatus = async id => {
  const { data } = await apiClient.delete(`/quotation-statuses/${id}`)
  return data
}

// Get all quotation statuses without pagination
export const getAllQuotationStatuses = async (params = {}) => {
  const { data } = await apiClient.get("/quotation-statuses", {
    params: { ...params, all: true },
  })
  return data
}

// Search quotation statuses by name or slug
export const searchQuotationStatuses = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/quotation-statuses", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed quotation statuses
export const getTrashedQuotationStatuses = async (params = {}) => {
  const { data } = await apiClient.get("/quotation-statuses/trashed", { params })
  return data
}

// Get a quotation status by slug
export const getQuotationStatusBySlug = async slug => {
  const { data } = await apiClient.get(`/quotation-statuses/slug/${slug}`)
  return data
}

// Restore a trashed quotation status
export const restoreQuotationStatus = async id => {
  const { data } = await apiClient.post(`/quotation-statuses/${id}/restore`)
  return data
}

// Permanently delete a quotation status
export const forceDeleteQuotationStatus = async id => {
  const { data } = await apiClient.delete(`/quotation-statuses/${id}/force-delete`)
  return data
}
